// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Main_MainContainer__\\+LDsH{
    margin-right:20%;
    margin-left: 80px;
    transition: margin-right 0.3s ease-in-out, margin-left 0.3s ease-in-out;
    z-index: 2;

}
.Main_hiddenChat__PSoo2{
    margin-right: 0;
}
@media screen and (max-width:1000px) {
    .Main_MainContainer__\\+LDsH{
        margin:0;
        
    }
}`, "",{"version":3,"sources":["webpack://./src/Main.module.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,uEAAuE;IACvE,UAAU;;AAEd;AACA;IACI,eAAe;AACnB;AACA;IACI;QACI,QAAQ;;IAEZ;AACJ","sourcesContent":[".MainContainer{\n    margin-right:20%;\n    margin-left: 80px;\n    transition: margin-right 0.3s ease-in-out, margin-left 0.3s ease-in-out;\n    z-index: 2;\n\n}\n.hiddenChat{\n    margin-right: 0;\n}\n@media screen and (max-width:1000px) {\n    .MainContainer{\n        margin:0;\n        \n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"MainContainer": `Main_MainContainer__+LDsH`,
	"hiddenChat": `Main_hiddenChat__PSoo2`
};
export default ___CSS_LOADER_EXPORT___;
